export const labelUpdatedAt = label => label.updateTime || label.updatedAt || label.createTime || label.createdAt;
export function labelStatus(label) {
  const status=String(label.status || 'draft').toLowerCase();
  return ['published','publish','online'].includes(status) ? 'published' : status;
}
export const labelStatusText = status => ({published:'已发布',draft:'草稿',pending:'待审核',processing:'处理中',approved:'已通过',rejected:'未通过',offline:'已下线'}[status] || status);
export function filterLabels(labels, {keyword='',status='all',dateFrom='',dateTo=''}) {
  const word=keyword.trim().toLocaleLowerCase();
  const start=dateFrom ? new Date(`${dateFrom}T00:00:00`).getTime() : -Infinity;
  const until=dateTo ? new Date(`${dateTo}T00:00:00`) : null;
  if (until) until.setDate(until.getDate()+1);
  const end=until ? until.getTime() : Infinity;
  return labels.filter(label=>{
    if (word && !String(label.labelName || label.name || '').toLocaleLowerCase().includes(word)) return false;
    if (status!=='all' && labelStatus(label)!==status) return false;
    if (dateFrom || dateTo) {
      const time=new Date(labelUpdatedAt(label)).getTime();
      if (!Number.isFinite(time) || time<start || time>=end) return false;
    }
    return true;
  });
}
function unpack(result) {
  if (Array.isArray(result)) return {list:result,total:result.length};
  const list=result?.list ?? result?.records ?? (Array.isArray(result?.data) ? result.data : result?.data?.list ?? result?.data?.records);
  if (!Array.isArray(list)) throw new Error('标签列表响应格式异常，请刷新后重试。');
  const raw=result.total ?? result.totalCount ?? result.data?.total ?? result.data?.totalCount;
  const total=raw!==undefined && raw!==null && raw!=='' ? Number(raw) : null;
  if (total!==null && (!Number.isFinite(total) || total<0)) throw new Error('标签总数异常，请刷新后重试。');
  return {list,total};
}
// Use the existing permission-scoped endpoint, never an administrator/all-users API.
export async function fetchAllLabels(fetchPage, isCurrent=()=>true) {
  const collected=new Map();
  let total=null;
  for (let pageNum=1; pageNum<=10000; pageNum+=1) {
    const result=await fetchPage({pageNum,pageSize:200});
    if (!isCurrent()) return null;
    const page=unpack(result);total=page.total;
    if (!page.list.length) {
      if (total!==null && collected.size<total) throw new Error('标签未完整加载，请刷新后重试。');
      return [...collected.values()];
    }
    let added=0;
    page.list.forEach((label,index)=>{
      const key=label.id ?? label.labelId ?? `row-${pageNum}-${index}`;
      if (!collected.has(key)) added+=1;
      collected.set(key,label);
    });
    if (total!==null && collected.size>=total) return [...collected.values()];
    if (!added) throw new Error('标签分页未前进，未能完整加载，请刷新后重试。');
  }
  throw new Error('标签分页异常，未能完整加载，请刷新后重试。');
}
